/**
 * LoadingScreen — pantalla de carga con engranes girando + barra de progreso.
 */
import { useEffect, useState } from "react";

export default function LoadingScreen({ message = "Cargando sistema..." }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setProgress((p) => (p >= 95 ? 95 : p + Math.random() * 8));
    }, 240);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] bg-[#0A3747] flex flex-col items-center justify-center" data-testid="loading-screen">
      <div className="relative w-32 h-32 mb-8">
        {/* Engranaje grande */}
        <svg className="absolute inset-0 gear-spin" viewBox="0 0 100 100" width="128" height="128">
          <defs>
            <linearGradient id="gear-grad-1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#E0E621" />
              <stop offset="100%" stopColor="#9BB300" />
            </linearGradient>
          </defs>
          <path
            d="M50 5 L55 15 L65 12 L67 22 L77 25 L75 35 L85 40 L80 50 L85 60 L75 65 L77 75 L67 78 L65 88 L55 85 L50 95 L45 85 L35 88 L33 78 L23 75 L25 65 L15 60 L20 50 L15 40 L25 35 L23 25 L33 22 L35 12 L45 15 Z"
            fill="url(#gear-grad-1)"
          />
          <circle cx="50" cy="50" r="15" fill="#0A3747" />
          <circle cx="50" cy="50" r="6" fill="#E0E621" />
        </svg>
        {/* Engranaje pequeño superpuesto */}
        <svg className="absolute -bottom-2 -right-2 gear-spin-reverse" viewBox="0 0 100 100" width="56" height="56">
          <path
            d="M50 10 L57 20 L67 17 L70 27 L80 30 L77 40 L85 47 L77 55 L80 65 L70 68 L67 78 L57 75 L50 85 L43 75 L33 78 L30 68 L20 65 L23 55 L15 47 L23 40 L20 30 L30 27 L33 17 L43 20 Z"
            fill="#E0E621"
          />
          <circle cx="50" cy="50" r="12" fill="#0A3747" />
          <circle cx="50" cy="50" r="5" fill="#E0E621" />
        </svg>
      </div>

      <div className="text-[#E0E621] font-mono text-[10px] uppercase tracking-[0.3em] mb-2">Alfa-Field Connect</div>
      <div className="text-white text-lg font-medium mb-8" style={{ fontFamily: "Space Grotesk" }}>{message}</div>

      {/* Barra de progreso */}
      <div className="w-64 h-1.5 bg-white/10 rounded-full overflow-hidden">
        <div
          className="h-full shimmer-bg rounded-full transition-all"
          style={{ width: `${progress}%`, transitionDuration: "240ms" }}
        />
      </div>
      <div className="text-white/40 font-mono text-xs mt-3">{Math.round(progress)}%</div>
    </div>
  );
}
